import { render, staticRenderFns } from "./MasterBlock.vue?vue&type=template&id=489174d5&scoped=true"
import script from "./MasterBlock.vue?vue&type=script&lang=js"
export * from "./MasterBlock.vue?vue&type=script&lang=js"
import style0 from "./MasterBlock.vue?vue&type=style&index=0&id=489174d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489174d5",
  null
  
)

export default component.exports
import {QTd,QTable,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTd,QTable,QBtn})
